import { CustomUser } from '@/models/custom-user.model';
import router from '@/router';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Authentication = namespace('authentication');

@Component
export default class LoginView extends Vue {

    @Authentication.State('user') private user: CustomUser;
    @Authentication.State('token') private token: string;
    @Authentication.State('inFlight') private inFlight: boolean;
    @Authentication.Action('login') private login: any;
    @Authentication.Action('logout') private logout: any;

    public credentials: any = {
        email: '',
        password: '',
    };

    public submitted: boolean = false;

    public mounted() {
        if (this.user && this.token) {
            router.push('/');
        }
    }

    public handleSubmit() {
        this.submitted = true;
        const { email, password } = this.credentials;

        if (email && password) {
            this.login(this.credentials).then(
                () => {
                    router.push('/admin');
                }, () => {
                    console.log('FAILED');
                },
            );
        }
    }

}
